import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Title from './Title';
import StationsList from '../Data/sampleprojectdata.json';
import ProjectInfo from '../components/ProjectDetails';
import Grid from '@mui/material/Grid';

const projectName = localStorage.getItem("projectName")
const projectInformation = StationsList.find(project => project.name === projectName);

// Generate Order Data
function createData(id, name, Location, AssetId, category) {
    return { id, name, Location, AssetId, category };
}

function preventDefault(event) {
    event.preventDefault();
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function ProjectDetails() {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <React.Fragment>
            <Title>{projectName} Project Details</Title>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Project Info" {...a11yProps(0)} />
                        <Tab label="Sensor Info" {...a11yProps(1)} />
                        <Tab label="BIM Data" {...a11yProps(2)} />
                        <Tab label="3D Models" {...a11yProps(3)} />
                        <Tab label="Drawings" {...a11yProps(4)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Grid container spacing={2} >
                        <Grid item xs={2} justify="left">
                            <h3>Name: {projectInformation.name}</h3>
                            <h3>Location: {projectInformation.location}</h3>
                            <h3>Description: {projectInformation.description}</h3>
                        </Grid>

                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Grid item xs={4}>
                        <h3>Oil Temperature Sensors: {projectInformation.oiltempSensors.length} </h3>
                        <h3>Moisture Sensors: {projectInformation.moistureSensors.length} </h3>
                        <h3>DGA Sensors: {projectInformation.dgaSensors.length} </h3>
                        <h3>SF6 Sensors: {projectInformation.sf6Sensors.length} </h3>
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Grid item xs={4}>
                        <h3>BIM Data Listed Here</h3>
                        <p>Extracted list of all BIM properties available</p>
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <Grid item xs={4}>
                        <h3>Project Models</h3>
                        <p>A list of all linked 3D Models available.</p>
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Grid item xs={4}>
                        <h3>Drawing List</h3>
                        <p>A list of all linked drawings available.</p>
                    </Grid>
                </TabPanel>
            </Box>

            {/* {StationsList.map((station) => (
            <TableRow key={station.id}>
              <TableCell>{station.name}</TableCell>
              <TableCell>{station.location}</TableCell>
              <TableCell>{station.assetId}</TableCell>
              <TableCell align="right">{`${station.category}`}</TableCell>
            </TableRow>
          ))} */}


        </React.Fragment>
    );
}
